import { render, staticRenderFns } from "./video-AntMedia.vue?vue&type=template&id=af57116a&scoped=true&"
import script from "./video-AntMedia.vue?vue&type=script&lang=js&"
export * from "./video-AntMedia.vue?vue&type=script&lang=js&"
import style0 from "./video-AntMedia.vue?vue&type=style&index=0&id=af57116a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af57116a",
  null
  
)

export default component.exports